export enum CardCondition {
	MINT = "mint",
	NEAR_MINT = "near_mint",
	SLIGHTLY_PLAYED = "slightly_played",
	MODERATELY_PLAYED = "moderately_played",
	HEAVILY_PLAYED = "heavily_played",
	DAMAGED = "damaged",
}

export const cardConditionReadable = {
	[CardCondition.MINT]: "Mint",
	[CardCondition.NEAR_MINT]: "Near Mint",
	[CardCondition.SLIGHTLY_PLAYED]: "Slightly Played",
	[CardCondition.MODERATELY_PLAYED]: "Moderately Played",
	[CardCondition.HEAVILY_PLAYED]: "Heavily Played",
	[CardCondition.DAMAGED]: "Damaged",
};
